import { useCallback } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  GRAPHQL_HEADER,
  httpMethods,
  IGeneralRequestResponse,
  IGraphQlQuery,
  IHttpHookResponseAwaitable,
} from '@services/httpClientService';

import { IServicesResponseData } from '../../model';
import { IInsuranceData } from '../model';

import { ADD_INSURANCE_MUTATION } from './addInsuranceMutation';
import { IAddInsuranceResponse } from './model';

const mappingFunction = (
  result: IAddInsuranceResponse,
): IGeneralRequestResponse<IServicesResponseData<IInsuranceData>> => result.addInsurance;

export const usePostInsuranceAwaitable = (): IHttpHookResponseAwaitable<
  IGeneralRequestResponse<IServicesResponseData<IInsuranceData>>
> => {
  const { request: awaitableRequest } = useHttpClientAwaitable<
    IGeneralRequestResponse<IServicesResponseData<IInsuranceData>>,
    IGraphQlQuery,
    IAddInsuranceResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.ECartApiKeys.CART_INSURANCE_URL,
    mappingFunction,
    customHeaders: GRAPHQL_HEADER,
  });

  const request = useCallback(() => {
    const payload = { query: ADD_INSURANCE_MUTATION };

    return awaitableRequest({ data: payload });
  }, [awaitableRequest]);

  return { request };
};
